import React from "react";
import "../Components/AboutHeader/AboutHeader";
import AboutHeader from "../Components/AboutHeader/AboutHeader";
import AboutContent from "../Components/AboutContent/AboutContent";
// import Developers from "../Components/Developers/Developers";
import Footer from "../Components/Footer/Footer";

const About = () => {
  return (
    <div>
      <AboutHeader />
      <AboutContent />
      {/* <Developers /> */}
      <Footer />
    </div>
  );
};

export default About;
